import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const MoveIn = {
  Content: lazy(() => import('components/move-in/components/MoveInContent')),
  Template: lazy(() => import('components/app/routes/NonRevampScreenTemplate'))
};

export default MoveIn;
